export const QUERY_CACHE_KEYS = {
  ivSDKSchema: 'ivSDKSchema',
  formFields: 'formFields',
  reservation: 'reservation',
  apiClient: 'apiClient',
  locations: 'locations',
  phoneCodes: 'phoneCodes',
  summary: 'summary',
  housing: 'housing',
  customForm: 'customForm',
  customFormById: 'customFormById',
  guestGroup: 'guestGroup',
  guest: 'guest',
  paymentSettings: 'paymentSettings',
  reservationPayments: 'reservationPayments',
  paymentsCart: 'paymentsCart',
  taxExemptions: 'taxExemptions',
  guidebooksByHousing: 'guidebooksByHousing',
  season: 'season',
  seasonGuests: 'seasonGuests',
  propertyProtections: 'propertyProtections',
  insuranceSetup: 'insuranceSetup',
  paginatedSpanishResidenceCities: 'paginatedSpanishResidenceCities',
  paginatedCountriesList: 'paginatedCountriesList',
  paginatedProvincesList: 'paginatedProvincesList',
  paginatedCitiesList: 'paginatedCitiesList',
  paginatedDistrictsList: 'paginatedDistrictsList',
  paginatedMunicipalitiesList: 'paginatedMunicipalitiesList',
  paginatedPhoneCodesList: 'paginatedPhoneCodesList',
  orderHistory: 'orderHistory',
  deleteDeal: 'deleteDeal',
  createOrUpdateBulkLock: 'createOrUpdateBulkLock',
  privacyPolicySettings: 'privacyPolicySettings',
  locks: 'locks',
  lockConditions: 'lockConditions',
  unlockDoor: 'unlockDoor',
  locksRooms: 'locksRooms',
  downloadFileDocuments: 'downloadFileDocuments',
  template: 'template',
  contracts: 'contracts',
  reservationBookingReference: 'reservationBookingReference',
  housingLocation: 'housingLocation',
  offers: 'offers',
  offer: 'offer',
  topOffers: 'topOffers',
  guruWalkTours: 'guruWalkTours',
  deals: 'deals',
  guidebooks: 'guidebooks',
  guidebook: 'guidebook',
  ipDetails: 'ipDetails',
  guidebookGroups: 'guidebookGroups',
  ivIntent: 'ivIntent',
  user: 'user',
  participants: 'participants',
  verificationSettings: 'verificationSettings',
  checkoutSettings: 'checkoutSettings',
  multiPayment: 'multiPayment',
  addonMultiPayment: 'addonMultiPayment',
  esimPackages: 'esimPackages',
  esims: 'esims',
  esimFeature: 'esimFeature',
} as const;
